import { create } from 'zustand';
import { ApiUtils, MiscApi, RequestStrategyEnum } from '@shared/api';

interface UseNationalitiesStore {
  loading: boolean;
  data: string[];
  error: string | null;
  getNationalities: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useNationalitiesStore = create<UseNationalitiesStore>((set) => ({
  loading: false,
  error: null,
  data: [],

  getNationalities: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getNationalities(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
